import { Box } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";
import {
  AddonDesc,
  AddonHeading,
  AddonWrapper,
  VariantOptionsContainer,
  VariantOption,
  SpecialOfferTag,
  StrikethroughPrice,
  ActualPrice
} from "./styles";
import DOMPurify from "isomorphic-dompurify";
import { useContext } from "react";
import { Context } from "@components/useContext/context";
import { useOnload } from "@utils/useOnLoad";
import { resolvePath } from "@utils/resolvePath";

const Addon = ({ children, ...props }) => {
  const {
    src,
    heading,
    description,
    actions,
    styles,
    variants,
  } = props || {};

  const { isDesktop } = useContext(Context);

  const { on_load } = actions || {};

  console.log({ actions });

  useOnload({ on_load });

  return (
    <Box>
      <AddonWrapper width="auto">
        <ImageContainer
          styles={styles}
          imgSrc={src}
          width={isDesktop ? 88 : 80}
          height={isDesktop ? 88 : 80}
        />
        <AddonHeading>{heading}</AddonHeading>
        {description.map((item, index) => (
          <AddonDesc
            key={index}
            style={{ marginTop: "16px" }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(item.text)
            }}
          />
        ))}

        {variants && (
          <VariantOptionsContainer>
            {variants.map((variant, index) => (
              <VariantOption key={index} selected={variant.isSelected}>
                {variant.specialOffer && (
                  <SpecialOfferTag>Special offer</SpecialOfferTag>
                )}
                <div>
                  <span>₹{variant.coverage} lakh coverage</span>
                  <div>
                    {variant.originalPrice && (
                      <StrikethroughPrice>
                        ₹{variant.originalPrice}
                      </StrikethroughPrice>
                    )}
                    <ActualPrice>₹{variant.price}</ActualPrice>
                  </div>
                </div>
              </VariantOption>
            ))}
          </VariantOptionsContainer>
        )}
      </AddonWrapper>
    </Box>
  );
};

export default Addon;
